export default __webpack_public_path__ + "static/media/whatsapp.554da2d1.svg";